import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter044() {
  return <KbChapterPage slug="chapter-044" />;
}

(Chapter044 as unknown as { path: string }).path = "/theory-album/044";
